export default "__VITE_ASSET__JS$wcNGL__"